import { Modal } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import PortletBody from '../../../../app/components/portlet/PortletBody';
import CompanyListingTable from '../../listing/CompanyListingTable';
import SearchIcon from '../../../../app/components/svgIcons/SearchIcon';
import StyledIconInput from '../../../../app/components/styledComponents/StyledIconInput';
import { STATUSES } from '../../../../utils/Statuses';
import styled from 'styled-components';
import SortIcon from '../../../../app/components/svgIcons/SortIcon';
import { StyledLabel } from '../../../Campaigns/CampaignDetails';
import theme from '../../../../utils/themes';
import StyledFilterTabs from '../../../../app/components/styledComponents/StyledFilterTabs';
import StyledToolTip from '../../../../app/components/styledComponents/StyledToolTip';
import PauseIcon from '../../../../app/components/svgIcons/PauseIcon';
import StyledButton from '../../../../app/components/styledComponents/StyledButton';
import StyledRadioButton from '../../../../app/components/radio/StyledRadioButton';
import { Wrap } from '../../../../assets/styledComponents/Global';
import { sortData } from '../../../Products/assets/utills';
import { StyledScrollView } from '../../../../app/components/styledComponents/ScrollView';
import { useChildCompaniesUpdateMutation, useGetChildCompaniesQuery } from '../../companyApiSlice';
import { Link } from 'react-router-dom';
import PaginationPerPage from '../../../../app/components/pagination/PaginationPerPage';
import { getStatusFriendly } from '../../../../utils/helper';
import StyledCheckbox from '../../../../app/components/checkbox/StyledCheckbox';
import CustomDropdown from '../../../../app/components/dropdown/CustomDropDown';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import EditIcon from '../../../../app/components/svgIcons/EditIcon';
import SlashCircleCIon from '../../../../app/components/svgIcons/SlashCircleIcon';
import OptionFillIcon from '../../../../app/components/svgIcons/OptionFillIcon';
import TrashIcon from '../../../../app/components/svgIcons/TrashIcon';
import CrossCircleIcon from '../../../../app/components/svgIcons/CrossCircleIcon';
import StyledColoredTag from '../../../../app/components/styledComponents/StyledColoredTag';
import OnlineIcon from '../../../../app/components/svgIcons/OnlineIcon';
import { toast } from 'react-toastify';
import TickCircleIcon from '../../../../app/components/svgIcons/TickCircleIcon';

const SubsidiariesModal = ({ show, onHide, companyId, setSubsidiariesModal, setCompanyEdit, setCompanyDetails }) => {
  const [isOpen, setIsopen] = useState(false);
  const [sortFilter, setSortFilter] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(false);
  const selectColumnRef = useRef(null);
  const sortFilterRef = useRef(null);
  const [updateChild] = useChildCompaniesUpdateMutation();

  const initialFilters = {
    jobs: [],
    perPage: 5,
    page: 1,
    sortedColumn: { path: 'createdAt', order: 'DESC' },
    query: '',
  };

  const [listing, setListing] = useState({ ...initialFilters });

  const { data: childCompanies, refetch } = useGetChildCompaniesQuery({
    params: {
      perPage: listing.perPage,
      page: listing.page,
      query: listing.query && listing.query,
      sort: listing.sortedColumn.path,
      sortDir: listing.sortedColumn.order,
      // ...filters,
    },
    id: companyId?.superCompanyId,
  },
    {
      skip: !companyId.superCompanyId,
    });


  const [timer, setSearchTimer] = useState(null);
  const handleSearch = (evt) => {
    clearTimeout(timer);
    const query = evt.target.value;
    // setSearch(query);
    const newTimer = setTimeout(() => {
      setListing({ ...listing, page: 1, query: query });
    }, 2000);
    setSearchTimer(newTimer);
  };
  const handleSort = (sort) => {
    const sortBlacklist = ['hired', 'statusId', 'account.firstName'];
    if (!sortBlacklist.includes(sort.path)) {
      setListing((prevState) => ({
        ...prevState,
        sortedColumn: { ...sort },
        page: 1,
      }));
    }
  };
  const handlePerPageChange = (perPage) => {
    setListing((prevState) => ({
      ...prevState,
      perPage: perPage.target.innerText,
      page: 1,
    }));
  };

  const handleSubsAction = (comp, id) => {
    const payload = {
      id: comp?.id,
      companyName: comp?.name,
      telephone: comp?.telephone,
      careerSiteUrl: comp?.careerSiteUrl,
      statusId: id
    }
    updateChild(payload)
      .unwrap()
      .then((res) => {
        toast.success(res?.message || `Company ${id === STATUSES.LIVE ? 'Active' : 'Inactive'} Successfully`);
        refetch();
      });
  }
  const statusColor = [
    { statusId: 4, color: 'danger' },
    { statusId: 3, color: 'orange' },
    { statusId: 2, color: 'success' },
    { statusId: 16, color: 'success' },
    { statusId: 1, color: 'info' },
  ];
  const getTagColor = (statusId) => {
    const colour = statusColor?.find((i) => i.statusId === statusId)?.color;
    return colour;
  };
  const handlePageChange = ({ selected }) => {
    setListing((prevState) => ({
      ...prevState,
      page: selected + 1,
    }));
  };
  const [newColumn, setNewColumn] = useState([]);
  const [column, setColumn] = useState([
    {
      id: 1,
      label: 'Name',
      isChecked: true,
      alignBody: 'text-left align-middle ps-4 py-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (comp) => (
        <Link to={`/companies/${comp?.id}`} onClick={() => onHide()} className="text-decoration-none">
          <h5 className="m-0 cut-text"> {comp?.name || '-'}</h5>
          <span className="small cut-text">{comp?.id || '-'}</span>
        </Link>
      ),
    },
    {
      id: 2,
      isChecked: true,
      label: 'Location',
      alignBody: 'text-left align-middle ps-4 py-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (comp) => (
        <StyledLabel color={theme.textColor} weight="500px">
          {comp?.location ? comp?.location : '-'}
        </StyledLabel>
      ),
    },
    {
      id: 3,
      isChecked: true,
      label: 'Licence',
      alignBody: 'text-left align-middle ps-4 py-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (comp) => (
        <span className="m-0">
          {comp?.companyLicence[0]?.licence?.name || '-'}
        </span>
      ),
    },
    {
      id: 4,
      isChecked: true,
      label: 'Owner',
      alignBody: 'text-left align-middle ps-4 py-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (comp) => (
        <span className="m-0">
          {`${comp?.account[0]?.firstName || comp?.account[0]?.lastName
            ? `${comp?.account[0]?.firstName || ''} ${comp?.account[0]?.lastName || ''
            }`
            : '-'
            }`}
        </span>
      ),
    },
    {
      id: 5,
      isChecked: true,
      label: 'Status',
      alignBody: 'text-left align-middle ps-4 py-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (comp) => (
        <div className="d-flex">
          <StyledColoredTag
            className="rounded-pill mx-0"
            variant={getTagColor(comp?.statusId)}
          >
            <OnlineIcon color={getTagColor(comp?.statusId)} className="me-1" />{' '}
            {getStatusFriendly(comp?.statusId) || '-'}
          </StyledColoredTag>
        </div>
      ),
    },
    {
      id: 8,
      key: 'actions',
      isChecked: true,
      label: 'Actions',
      alignBody: 'text-center align-middle ps-4 py-3 text-nowrap',
      alignHeader: 'text-center cursor-pointer ps-4 py-3',
      content: (comp) => (
        <div className="d-flex justify-content-center align-items-center">
          <Link
            variant="text"
            className="text-decoration-none  pe-2"
            onClick={() => {
              setSubsidiariesModal(false);
              setCompanyEdit(true);
              setCompanyDetails(comp);
            }}
          >
            <EditIcon size={18} />
            {/* <StyledToolTip title="Edit Company" className="position-fixed" childrenClass={'ms-0 '}>
              
            </StyledToolTip> */}
          </Link>
          {comp?.statusId !== 3 && (
            <Link
              variant="text"
              className="text-decoration-none  px-2"
              onClick={() => handleSubsAction(comp, STATUSES.SUSPENDED)}
            >
              <StyledToolTip title="Suspend" childrenClass={'ms-0'}>
                {' '}
                <SlashCircleCIon />
              </StyledToolTip>
            </Link>
          )}
          <Link
            variant="text"
            className="text-decoration-none feature-pending px-2"
            to={''}
          >
            <StyledToolTip
              title="Edit Company"
              className="mt-2"
              placement="top"

            >
              {' '}
              <OptionFillIcon rotate={'left'} />
            </StyledToolTip>
          </Link>
          <div className="d-flex">
            <CustomDropdown
              toggleClassName={'bg-transparent px-0'}
              menuClassName={'adminJobs'}
              dropdownToggle={
                <div
                  className={`account-menu ${'bg-transparent ps-0 ms-2'} `}
                >
                  <OptionFillIcon rotate={'left'} />
                </div>
              }
              dropdownMenu={
                <>
                  <DropdownItem
                    className="py-1"
                    onClick={() => handleSubsAction(comp, STATUSES.DELETE)}
                  >
                    <span className="dark-text pb-2">
                      <TrashIcon />
                    </span>
                    <span className="ms-3 text-secondary pb-2">
                      Delete
                    </span>
                  </DropdownItem>
                  <DropdownItem
                    className="py-1"
                    onClick={() => handleSubsAction(comp, comp?.statusId === STATUSES.INACTIVE ? STATUSES.LIVE : STATUSES.INACTIVE)}
                  >
                    <span className="dark-text pb-2">
                      {comp?.statusId === STATUSES.INACTIVE ? <TickCircleIcon /> : <CrossCircleIcon />}

                    </span>
                    <span className="ms-3 text-secondary pb-2">
                      {comp?.statusId === STATUSES.INACTIVE ? 'Mark as Active' : 'Mark as Inactive'}

                    </span>
                  </DropdownItem>
                </>
              }
            />
          </div>
        </div>
      )
    }
  ]);

  const handleCHeck = (item) => {
    const tempColumn = [...column];
    const newItemIndex = column.findIndex((t) => t.id === item.id);
    tempColumn[newItemIndex].isChecked = !tempColumn[newItemIndex].isChecked;
    setColumn(tempColumn);
  };

  const handleSelectedColumn = () => {
    const newArr = [];
    column.map((item) => item.isChecked && newArr.push(item));
    setNewColumn(newArr);
    setSelectedColumns(false);
  };

  useEffect(() => {
    handleSelectedColumn();
  }, []);

  let ToggleFilterbar = (item) => {
    setIsopen(item === 'filter' ? !isOpen : false);
    setSortFilter(item === 'sort' ? !sortFilter : false);
    setSelectedColumns(item === 'selected' ? !selectedColumns : false);
  };

  const handleSortBy = (item) => {
    const prevFilters = { ...listing };
    prevFilters.sortedColumn = item;
    setListing(prevFilters);
  };

  useEffect(() => {
    if (show) refetch();
  }, [show]);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSortFilter(false);
          setSelectedColumns(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(
    (sortFilter && sortFilterRef) || (selectedColumns && selectColumnRef),
  );

  return (
    <Modal show={show} centered onHide={onHide} size={'xl'}>
      <Modal.Header
        closeButton
        className="border-bottom-0 fs-5 pb-0 align-items-center mb-3 ps-2"
      >
        <Modal.Title as="h4" className="flex-grow-1 p-2 fs-2 flex-center">
          {companyId?.name || '-'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex  flex-column bg-body rounded ">
        <StyledScrollView>
          <PortletBody className="p-3 w-100 ">
            <>
              <Wrap className="d-flex justify-content-between align-items-center mb-3 position-relative">
                <StyledIconInput
                  icon={<SearchIcon />}
                  className="mw-50"
                  $maxWidth="55%"
                  // value={search} // setting a value manually here triggers react warnings
                  onChange={handleSearch}
                  placeholder="Search by company name"
                />
                <StyledFilterTabs padding="5px">
                  <div className="btn-group " role="group">
                    <button
                      className="btn"
                      id="sort"
                      onClick={() => ToggleFilterbar('sort')}
                    >
                      <StyledToolTip title="Sort by" childrenClass={'ms-0'}>
                        <SortIcon size={15} />
                      </StyledToolTip>
                    </button>

                    <button
                      className="btn"
                      onClick={() => ToggleFilterbar('selected')}
                    >
                      <PauseIcon size={15} />
                    </button>
                  </div>
                </StyledFilterTabs>
                <div
                  ref={selectColumnRef}
                  className="d-flex rounded flex-column"
                >
                  {selectedColumns && (
                    <DropdownMenu className="ms-auto shadow ">
                      <div className="d-flex justify-content-between flex-column mb-3 ps-4">
                        <h5 className="mb-0 ">Column Modifier</h5>
                        <p className="mb-0 ">Modify column view</p>
                      </div>
                      {column.map((item, index) => {
                        return (
                          <StyledBgEffect
                            className="d-flex align-items-center py-2 ps-4 cursor-pointer"
                            key={`cl-${index}`}
                          >
                            <StyledCheckbox
                              size="14"
                              value={item.isChecked}
                              onChange={() => handleCHeck(item)}
                            />
                            <h6 className="ms-2 mb-0">{item.label}</h6>
                          </StyledBgEffect>
                        );
                      })}
                      <div className="mx-4 mt-2">
                        <StyledButton
                          onClick={handleSelectedColumn}
                          className="w-100 p-1"
                        >
                          Apply
                        </StyledButton>
                      </div>
                    </DropdownMenu>
                  )}
                </div>
                <div ref={sortFilterRef}>
                  {sortFilter && (
                    <DropdownMenu className="ms-auto shadow ">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0 ps-4">Sort by</h5>
                      </div>
                      {sortData?.map((item, index) => {
                        return (
                          <StyledBgEffect
                            className={`${item.value === 'nearest' ? 'feature-pending' : ''
                              } d-flex align-items-center py-2 ps-4 `}
                            key={`sort-${item.value}-index`}
                          >
                            <StyledRadioButton
                              size={15}
                              value={
                                listing.sortedColumn.path ===
                                item.sortvalue.path &&
                                listing.sortedColumn.order ===
                                item.sortvalue.order
                              }
                              label={item.label}
                              className="fw-bold"
                              onChange={() => handleSortBy(item.sortvalue)}
                            />
                          </StyledBgEffect>
                        );
                      })}
                    </DropdownMenu>
                  )}
                </div>
              </Wrap>
              <CompanyListingTable
                companies={childCompanies?.childCompanies ?? []}
                sortColumn={listing?.sortedColumn}
                onSort={handleSort}
                filterTable={newColumn}
              />
              <PaginationPerPage
                perPage={childCompanies?.perPage || 0}
                pageNo={childCompanies?.currentPage || 1}
                onPerPageChange={handlePerPageChange}
                totalCount={childCompanies?.totalCount || 0}
                onPageChange={handlePageChange}
              />

            </>
          </PortletBody>
        </StyledScrollView>
      </Modal.Body>
    </Modal>
  );
};

const StyledBgEffect = styled.div`
  &:hover {
    background-color: ${({ theme }) => theme.bodyBg};
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  min-width: 15rem;
  width: fit-content;
  padding: 0.5rem 0;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25rem;
`;

export default SubsidiariesModal;
